import LimitationTypes from './types';

const initialState = {
  loadingLimitation: false,
  limitation: {},
  loadingplanConfig: false,
  planConfig: {},
  error: null,
};

function limitationReducer(state = initialState, { type, payload }) {
  switch (type) {
    case LimitationTypes.FETCH_LIMITATION_START:
      return {
        ...state,
        loadingLimitation: true,
      };

    case LimitationTypes.FETCH_LIMITATION_SUCCESS:
      return {
        ...state,
        loadingLimitation: false,
        limitation: payload,
      };
    case LimitationTypes.FETCH_LIMITATION_FAILURE:
      return {
        ...state,
        loadingLimitation: false,
        error: payload,
      };
    case LimitationTypes.FETCH_PLANCONFIG_START:
      return {
        ...state,
        loadingplanConfig: true,
      };

    case LimitationTypes.FETCH_PLANCONFIG_SUCCESS:
      return {
        ...state,
        loadingplanConfig: false,
        planConfig: payload,
      };
    case LimitationTypes.FETCH_PLANCONFIG_FAILURE:
      return {
        ...state,
        loadingplanConfig: false,
        error: payload,
      };

    case LimitationTypes.RESET_STATE:
      return {
        ...state,
        loadingLimitation: false,
        limitation: [],
        error: null,
      };
    default:
      return state;
  }
}

export default limitationReducer;
